import React from 'react';

import Header from '../Component/Header';
import Footer from '../Component/Footer';
import { API_BASE } from "../api/apiConfig";

const Index = () => {
  return (
    <>
      <Header />


<main className="min-h-screen bg-[#0F172A]">
  <section className="relative overflow-hidden bg-gradient-to-b from-[#0F172A] to-[#1E293B] py-20 md:py-28">
    <div className="absolute inset-0 z-0 opacity-20">
      <img
        alt="Background pattern"
        decoding="async"
        data-nimg="fill"
        className="object-cover"
        style={{
          position: "absolute",
          height: "100%",
          width: "100%",
          inset: 0
        }}
        src="/diagonal-pattern.png"
      />
    </div>
    <div className="container relative z-10 mx-auto px-4 text-center md:px-6">
      <div className="mx-auto max-w-3xl">
        <h1 className="mb-6 text-4xl font-bold tracking-tight text-white md:text-5xl lg:text-6xl">
          Our Mission to <span className="text-primary">Connect</span> Travelers
          Worldwide
        </h1>
        <p className="mb-8 text-lg text-gray-300 md:text-xl">
          We're building a global community that transforms how people travel,
          connect, and experience the world together.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <a href="/community" className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-11 rounded-md px-8 bg-primary text-white hover:bg-primary/90">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-users mr-2 h-5 w-5"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx={9} cy={7} r={4} />
              <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
            Join Our Community
          </a>
          <a href="/experts">
            <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-11 rounded-md px-8 border-white/20 bg-white/5 text-white hover:bg-white/10">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-globe mr-2 h-5 w-5"
              >
                <circle cx={12} cy={12} r={10} />
                <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
                <path d="M2 12h20" />
              </svg>
              Meet Our Experts
            </button>
          </a>
        </div>
      </div>
    </div>
  </section>
  <section className="py-16 md:py-24">
    <div className="container mx-auto px-4 md:px-6">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="mb-6 text-3xl font-bold text-white md:text-4xl">
          Our Story
        </h2>
        <div className="mb-10 h-1 w-20 bg-primary mx-auto" />
      </div>
      <div className="grid gap-12 md:grid-cols-2 items-center">
        <div className="order-2 md:order-1">
          <h3 className="mb-4 text-2xl font-semibold text-white">
            From Solo Travelers to Global Community
          </h3>
          <p className="mb-4 text-gray-300">
            Connecting Traveller began in 2018 when our founders, avid travelers
            themselves, recognized a fundamental gap in the travel experience:
            authentic human connection.
          </p>
          <p className="mb-4 text-gray-300">
            After years of solo adventures across continents, they realized that
            the most memorable travel experiences weren't about the places they
            visited, but the people they met along the way.
          </p>
          <p className="mb-6 text-gray-300">
            What started as a simple meetup platform for travelers in major
            cities has evolved into a comprehensive ecosystem that connects
            travelers with local experts, fellow adventurers, and authentic
            experiences worldwide.
          </p>
          <div className="flex flex-wrap gap-4">
            <div className="flex items-center gap-2">
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/20">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-map-pin h-5 w-5 text-primary"
                >
                  <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                  <circle cx={12} cy={10} r={3} />
                </svg>
              </div>
              <span className="text-white">120+ Countries</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/20">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-users h-5 w-5 text-primary"
                >
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx={9} cy={7} r={4} />
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
              <span className="text-white">500K+ Members</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/20">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-globe h-5 w-5 text-primary"
                >
                  <circle cx={12} cy={12} r={10} />
                  <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
                  <path d="M2 12h20" />
                </svg>
              </div>
              <span className="text-white">10K+ Local Experts</span>
            </div>
          </div>
        </div>
        <div className="order-1 md:order-2 relative">
          <div className="relative h-[400px] overflow-hidden rounded-xl">
            <img
              alt="Travelers connecting around the world"
              loading="lazy"
              decoding="async"
              data-nimg="fill"
              className="object-cover"
              style={{
                position: "absolute",
                height: "100%",
                width: "100%",
                inset: 0,
                color: "transparent"
              }}
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/community-values-VNlLNGhRtOsdpCTaa8CBNHMyT2vwis.jpg"
            />
          </div>
          <div class="absolute -bottom-6 -left-6 h-32 w-32 rounded-lg bg-primary p-4 text-center text-white shadow-lg">
            <p class="text-3xl font-bold">5+</p>
            <p class="text-sm">Years Connecting Travelers</p>
        </div>
        </div>
      </div>
    </div>
  </section>
  <section className="bg-[#1E293B] py-16 md:py-24">
    <div className="container mx-auto px-4 md:px-6">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="mb-6 text-3xl font-bold text-white md:text-4xl">
          Our Core Values
        </h2>
        <div className="mb-10 h-1 w-20 bg-primary mx-auto" />
        <p className="mb-12 text-gray-300">
          These principles guide everything we do at Connecting Traveller, from
          product development to community management.
        </p>
      </div>
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        <div className="rounded-xl bg-[#0F172A]/80 p-6 transition-transform hover:scale-105">
          <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary/20">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-heart h-7 w-7 text-primary"
            >
              <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
            </svg>
          </div>
          <h3 className="mb-3 text-xl font-semibold text-white">
            Authentic Connections
          </h3>
          <p className="text-gray-300">
            We believe travel is about meaningful human connections that
            transcend cultural boundaries.
          </p>
        </div>
        <div className="rounded-xl bg-[#0F172A]/80 p-6 transition-transform hover:scale-105">
          <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary/20">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-globe h-7 w-7 text-primary"
            >
              <circle cx={12} cy={12} r={10} />
              <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
              <path d="M2 12h20" />
            </svg>
          </div>
          <h3 className="mb-3 text-xl font-semibold text-white">
            Cultural Respect
          </h3>
          <p className="text-gray-300">
            We promote responsible travel that honors local cultures,
            traditions, and environments.
          </p>
        </div>
        <div className="rounded-xl bg-[#0F172A]/80 p-6 transition-transform hover:scale-105">
          <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary/20">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-award h-7 w-7 text-primary"
            >
              <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526" />
              <circle cx={12} cy={8} r={6} />
            </svg>
          </div>
          <h3 className="mb-3 text-xl font-semibold text-white">
            Quality Experiences
          </h3>
          <p className="text-gray-300">
            We curate exceptional travel experiences and experts that exceed
            expectations.
          </p>
        </div>
        <div className="rounded-xl bg-[#0F172A]/80 p-6 transition-transform hover:scale-105">
          <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary/20">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-shield h-7 w-7 text-primary"
            >
              <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
            </svg>
          </div>
          <h3 className="mb-3 text-xl font-semibold text-white">
            Trust &amp; Safety
          </h3>
          <p className="text-gray-300">
            We prioritize creating a secure environment where travelers can
            connect with confidence.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section className="py-16 md:py-24">
    <div className="container mx-auto px-4 md:px-6">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="mb-6 text-3xl font-bold text-white md:text-4xl">
          How Connecting Traveller Works
        </h2>
        <div className="mb-10 h-1 w-20 bg-primary mx-auto" />
        <p className="mb-12 text-gray-300">
          Our platform brings together three key elements to transform your
          travel experience.
        </p>
      </div>
      <div className="grid gap-8 md:grid-cols-3">
        <div className="rounded-xl bg-gradient-to-b from-[#1E293B] to-[#0F172A] p-6 text-center">
          <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-primary/20">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-users h-10 w-10 text-primary"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx={9} cy={7} r={4} />
              <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
          <h3 className="mb-4 text-xl font-semibold text-white">
            Community Connection
          </h3>
          <p className="mb-4 text-gray-300">
            Join a global network of like-minded travelers. Share experiences,
            find travel companions, and participate in local meetups worldwide.
          </p>
          <a href="/community">
            <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 underline-offset-4 hover:underline h-10 px-4 py-2 text-primary hover:text-primary/80">
              Explore Community
            </button>
          </a>
        </div>
        <div className="rounded-xl bg-gradient-to-b from-[#1E293B] to-[#0F172A] p-6 text-center">
          <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-primary/20">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-compass h-10 w-10 text-primary"
            >
              <path d="m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z" />
              <circle cx={12} cy={12} r={10} />
            </svg>
          </div>
          <h3 className="mb-4 text-xl font-semibold text-white">
            Local Expertise
          </h3>
          <p className="mb-4 text-gray-300">
            Connect with verified local experts who provide personalized
            guidance, insider tips, and authentic experiences in destinations
            worldwide.
          </p>
          <a href="/experts">
            <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 underline-offset-4 hover:underline h-10 px-4 py-2 text-primary hover:text-primary/80">
              Find Experts
            </button>
          </a>
        </div>
        <div className="rounded-xl bg-gradient-to-b from-[#1E293B] to-[#0F172A] p-6 text-center">
          <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-primary/20">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-map-pin h-10 w-10 text-primary"
            >
              <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
              <circle cx={12} cy={10} r={3} />
            </svg>
          </div>
          <h3 className="mb-4 text-xl font-semibold text-white">
            Destination Discovery
          </h3>
          <p className="mb-4 text-gray-300">
            Explore curated destination guides, hidden gems, and authentic
            experiences recommended by our community and local experts.
          </p>
          <a href="/destinations">
            <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 underline-offset-4 hover:underline h-10 px-4 py-2 text-primary hover:text-primary/80">
              Explore Destinations
            </button>
          </a>
        </div>
      </div>
    </div>
  </section>
  <section className="bg-[#1E293B] py-16 md:py-24">
    <div className="container mx-auto px-4 md:px-6">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="mb-6 text-3xl font-bold text-white md:text-4xl">
          Meet Our Team
        </h2>
        <div className="mb-10 h-1 w-20 bg-primary mx-auto" />
        <p className="mb-12 text-gray-300">
          Our diverse team of travel enthusiasts is dedicated to building
          meaningful connections around the world.
        </p>
      </div>
      <div className="grid gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        <div className="group relative overflow-hidden rounded-xl bg-[#0F172A]/80 text-center">
          <div className="aspect-square overflow-hidden">
            <img
              alt="Sarah Johnson"
              loading="lazy"
              width={300}
              height={300}
              decoding="async"
              data-nimg={1}
              className="h-full w-full object-cover transition-transform group-hover:scale-110"
              style={{ color: "transparent" }}
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/member-1-bOpGjZCsPuoiXPcWozfOLLcloeHRto.jpg"
            />
          </div>
          <div className="p-6">
            <h3 className="mb-1 text-xl font-semibold text-white">
              Sarah Johnson
            </h3>
            <p className="mb-3 text-primary">Founder &amp; CEO</p>
            <p className="text-gray-300">
              Former solo backpacker with 50+ countries under her belt.
            </p>
          </div>
        </div>
        <div className="group relative overflow-hidden rounded-xl bg-[#0F172A]/80 text-center">
          <div className="aspect-square overflow-hidden">
            <img
              alt="Michael Chen"
              loading="lazy"
              width={300}
              height={300}
              decoding="async"
              data-nimg={1}
              className="h-full w-full object-cover transition-transform group-hover:scale-110"
              style={{}}
              src="/member-2.jpg"
            />
          </div>
          <div className="p-6">
            <h3 className="mb-1 text-xl font-semibold text-white">
              Michael Chen
            </h3>
            <p className="mb-3 text-primary">Co-Founder &amp; CTO</p>
            <p className="text-gray-300">
              Tech innovator passionate about connecting people through
              technology.
            </p>
          </div>
        </div>
        <div className="group relative overflow-hidden rounded-xl bg-[#0F172A]/80 text-center">
          <div className="aspect-square overflow-hidden">
            <img
              alt="Priya Sharma"
              loading="lazy"
              width={300}
              height={300}
              decoding="async"
              data-nimg={1}
              className="h-full w-full object-cover transition-transform group-hover:scale-110"
              style={{}}
              src="/member-3.jpg"
            />
          </div>
          <div className="p-6">
            <h3 className="mb-1 text-xl font-semibold text-white">
              Priya Sharma
            </h3>
            <p className="mb-3 text-primary">Head of Community</p>
            <p className="text-gray-300">
              Community building expert with a background in cultural
              anthropology.
            </p>
          </div>
        </div>
        <div className="group relative overflow-hidden rounded-xl bg-[#0F172A]/80 text-center">
          <div className="aspect-square overflow-hidden">
            <img
              alt="David Okafor"
              loading="lazy"
              width={300}
              height={300}
              decoding="async"
              data-nimg={1}
              className="h-full w-full object-cover transition-transform group-hover:scale-110"
              style={{}}
              src="/member-4.jpg"
            />
          </div>
          <div className="p-6">
            <h3 className="mb-1 text-xl font-semibold text-white">
              David Okafor
            </h3>
            <p className="mb-3 text-primary">Head of Experiences</p>
            <p className="text-gray-300">
              Former tour guide who's visited every continent, including
              Antarctica.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="py-16 md:py-24">
    <div className="container mx-auto px-4 md:px-6">
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        <div className="rounded-xl bg-[#1E293B] p-6 text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/20">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-users h-8 w-8 text-primary"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx={9} cy={7} r={4} />
              <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
          <p className="mb-2 text-3xl font-bold text-white">500K+</p>
          <p className="text-gray-300">Community Members</p>
        </div>
        <div className="rounded-xl bg-[#1E293B] p-6 text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/20">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-globe h-8 w-8 text-primary"
            >
              <circle cx={12} cy={12} r={10} />
              <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
              <path d="M2 12h20" />
            </svg>
          </div>
          <p className="mb-2 text-3xl font-bold text-white">120+</p>
          <p className="text-gray-300">Countries Covered</p>
        </div>
        <div className="rounded-xl bg-[#1E293B] p-6 text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/20">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-map-pin h-8 w-8 text-primary"
            >
              <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
              <circle cx={12} cy={10} r={3} />
            </svg>
          </div>
          <p className="mb-2 text-3xl font-bold text-white">10K+</p>
          <p className="text-gray-300">Local Experts</p>
        </div>
        <div className="rounded-xl bg-[#1E293B] p-6 text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/20">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-clock h-8 w-8 text-primary"
            >
              <circle cx={12} cy={12} r={10} />
              <polyline points="12 6 12 12 16 14" />
            </svg>
          </div>
          <p className="mb-2 text-3xl font-bold text-white">5M+</p>
          <p className="text-gray-300">Connections Made</p>
        </div>
      </div>
    </div>
  </section>
  <section className="bg-[#1E293B] py-16 md:py-24">
    <div className="container mx-auto px-4 md:px-6">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="mb-6 text-3xl font-bold text-white md:text-4xl">
          What Our Community Says
        </h2>
        <div className="mb-10 h-1 w-20 bg-primary mx-auto" />
      </div>
      <div className="grid gap-8 md:grid-cols-3">
        <div className="rounded-xl bg-[#0F172A]/80 p-6">
          <div className="mb-4 text-primary">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={32}
              height={32}
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M11.192 15.757c0-.88-.23-1.618-.69-2.217-.326-.412-.768-.683-1.327-.812-.55-.128-1.07-.137-1.54-.028-.16.036-.33.084-.51.144-.09.030-.18.056-.27.08l-2.03.6c.02-.93.09-1.79.2-2.6.36-.08.75-.19 1.16-.33.41-.14.8-.33 1.17-.57.37-.24.67-.52.9-.84.13-.15.22-.32.28-.5.06-.18.09-.37.09-.57 0-.38-.13-.7-.4-.96-.27-.26-.63-.39-1.09-.39-.43 0-.79.14-1.06.43-.27.29-.48.65-.63 1.09-.16.45-.28.93-.37 1.44-.08.5-.14 1.01-.19 1.52-.05.26-.09.51-.12.75l-.05.48c-.02.12-.04.22-.05.29l-.01.13v.04l1.67-.48c.04-.01.08-.03.12-.04.42-.13.8-.3 1.13-.51.33-.21.6-.45.8-.73.21-.27.31-.55.31-.84zm9.76 0c0-.88-.23-1.618-.69-2.217-.326-.412-.768-.683-1.327-.812-.55-.128-1.07-.137-1.54-.028-.16.036-.33.084-.51.144-.09.030-.18.056-.27.08l-2.03.6c.02-.93.09-1.79.2-2.6.36-.08.75-.19 1.16-.33.41-.14.8-.33 1.17-.57.37-.24.67-.52.9-.84.13-.15.22-.32.28-.5.06-.18.09-.37.09-.57 0-.38-.13-.7-.4-.96-.27-.26-.63-.39-1.09-.39-.43 0-.79.14-1.06.43-.27.29-.48.65-.63 1.09-.16.45-.28.93-.37 1.44-.08.5-.14 1.01-.19 1.52-.05.26-.09.51-.12.75l-.05.48c-.02.12-.04.22-.05.29l-.01.13v.04l1.67-.48c.04-.01.08-.03.12-.04.42-.13.8-.3 1.13-.51.33-.21.6-.45.8-.73.21-.27.31-.55.31-.84z" />
            </svg>
          </div>
          <p className="mb-6 text-gray-300">
            Connecting Traveller transformed my solo trip to Japan into an
            unforgettable social adventure. I met amazing people and discovered
            places I would have never found on my own.
          </p>
          <div className="flex items-center">
            <div className="mr-4 h-12 w-12 overflow-hidden rounded-full">
              <img
                alt="Emma S."
                loading="lazy"
                width={48}
                height={48}
                decoding="async"
                data-nimg={1}
                className="h-full w-full object-cover"
                style={{ color: "transparent" }}
                src="/testimonial-avatar.jpg"
              />
            </div>
            <div>
              <p className="font-semibold text-white">Emma S.</p>
              <p className="text-sm text-gray-400">London, UK</p>
            </div>
          </div>
        </div>
        <div className="rounded-xl bg-[#0F172A]/80 p-6">
          <div className="mb-4 text-primary">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={32}
              height={32}
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M11.192 15.757c0-.88-.23-1.618-.69-2.217-.326-.412-.768-.683-1.327-.812-.55-.128-1.07-.137-1.54-.028-.16.036-.33.084-.51.144-.09.030-.18.056-.27.08l-2.03.6c.02-.93.09-1.79.2-2.6.36-.08.75-.19 1.16-.33.41-.14.8-.33 1.17-.57.37-.24.67-.52.9-.84.13-.15.22-.32.28-.5.06-.18.09-.37.09-.57 0-.38-.13-.7-.4-.96-.27-.26-.63-.39-1.09-.39-.43 0-.79.14-1.06.43-.27.29-.48.65-.63 1.09-.16.45-.28.93-.37 1.44-.08.5-.14 1.01-.19 1.52-.05.26-.09.51-.12.75l-.05.48c-.02.12-.04.22-.05.29l-.01.13v.04l1.67-.48c.04-.01.08-.03.12-.04.42-.13.8-.3 1.13-.51.33-.21.6-.45.8-.73.21-.27.31-.55.31-.84zm9.76 0c0-.88-.23-1.618-.69-2.217-.326-.412-.768-.683-1.327-.812-.55-.128-1.07-.137-1.54-.028-.16.036-.33.084-.51.144-.09.030-.18.056-.27.08l-2.03.6c.02-.93.09-1.79.2-2.6.36-.08.75-.19 1.16-.33.41-.14.8-.33 1.17-.57.37-.24.67-.52.9-.84.13-.15.22-.32.28-.5.06-.18.09-.37.09-.57 0-.38-.13-.7-.4-.96-.27-.26-.63-.39-1.09-.39-.43 0-.79.14-1.06.43-.27.29-.48.65-.63 1.09-.16.45-.28.93-.37 1.44-.08.5-.14 1.01-.19 1.52-.05.26-.09.51-.12.75l-.05.48c-.02.12-.04.22-.05.29l-.01.13v.04l1.67-.48c.04-.01.08-.03.12-.04.42-.13.8-.3 1.13-.51.33-.21.6-.45.8-.73.21-.27.31-.55.31-.84z" />
            </svg>
          </div>
          <p className="mb-6 text-gray-300">
            As a local expert in Bangkok, I've connected with travelers from
            around the world. It's rewarding to share my city and culture while
            making global friendships.
          </p>
          <div className="flex items-center">
            <div className="mr-4 h-12 w-12 overflow-hidden rounded-full">
              <img
                alt="Somchai P."
                loading="lazy"
                width={48}
                height={48}
                decoding="async"
                data-nimg={1}
                className="h-full w-full object-cover"
                style={{}}
                src="/member-5.jpg"
              />
            </div>
            <div>
              <p className="font-semibold text-white">Somchai P.</p>
              <p className="text-sm text-gray-400">Bangkok, Thailand</p>
            </div>
          </div>
        </div>
        <div className="rounded-xl bg-[#0F172A]/80 p-6">
          <div className="mb-4 text-primary">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={32}
              height={32}
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M11.192 15.757c0-.88-.23-1.618-.69-2.217-.326-.412-.768-.683-1.327-.812-.55-.128-1.07-.137-1.54-.028-.16.036-.33.084-.51.144-.09.030-.18.056-.27.08l-2.03.6c.02-.93.09-1.79.2-2.6.36-.08.75-.19 1.16-.33.41-.14.8-.33 1.17-.57.37-.24.67-.52.9-.84.13-.15.22-.32.28-.5.06-.18.09-.37.09-.57 0-.38-.13-.7-.4-.96-.27-.26-.63-.39-1.09-.39-.43 0-.79.14-1.06.43-.27.29-.48.65-.63 1.09-.16.45-.28.93-.37 1.44-.08.5-.14 1.01-.19 1.52-.05.26-.09.51-.12.75l-.05.48c-.02.12-.04.22-.05.29l-.01.13v.04l1.67-.48c.04-.01.08-.03.12-.04.42-.13.8-.3 1.13-.51.33-.21.6-.45.8-.73.21-.27.31-.55.31-.84zm9.76 0c0-.88-.23-1.618-.69-2.217-.326-.412-.768-.683-1.327-.812-.55-.128-1.07-.137-1.54-.028-.16.036-.33.084-.51.144-.09.030-.18.056-.27.08l-2.03.6c.02-.93.09-1.79.2-2.6.36-.08.75-.19 1.16-.33.41-.14.8-.33 1.17-.57.37-.24.67-.52.9-.84.13-.15.22-.32.28-.5.06-.18.09-.37.09-.57 0-.38-.13-.7-.4-.96-.27-.26-.63-.39-1.09-.39-.43 0-.79.14-1.06.43-.27.29-.48.65-.63 1.09-.16.45-.28.93-.37 1.44-.08.5-.14 1.01-.19 1.52-.05.26-.09.51-.12.75l-.05.48c-.02.12-.04.22-.05.29l-.01.13v.04l1.67-.48c.04-.01.08-.03.12-.04.42-.13.8-.3 1.13-.51.33-.21.6-.45.8-.73.21-.27.31-.55.31-.84z" />
            </svg>
          </div>
          <p className="mb-6 text-gray-300">
            The community meetups in New York introduced me to a network of
            travel enthusiasts who've become close friends. We've even planned
            group trips together!
          </p>
          <div className="flex items-center">
            <div className="mr-4 h-12 w-12 overflow-hidden rounded-full">
              <img
                alt="Marcus J."
                loading="lazy"
                width={48}
                height={48}
                decoding="async"
                data-nimg={1}
                className="h-full w-full object-cover"
                style={{}}
                src="/host-avatar.jpg"
              />
            </div>
            <div>
              <p className="font-semibold text-white">Marcus J.</p>
              <p className="text-sm text-gray-400">New York, USA</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="relative overflow-hidden py-16 md:py-24 mb-mobile">
    <div className="absolute inset-0 z-0">
      <img
        alt="Join our community"
        loading="lazy"
        decoding="async"
        data-nimg="fill"
        className="object-cover opacity-20"
        style={{
          position: "absolute",
          height: "100%",
          width: "100%",
          inset: 0,
          color: "transparent"
        }}
        src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/premium-travel-bg-QEFwEm4E3JDndSBOxwnGwgABkEVOmR.jpg"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0F172A] to-transparent" />
    </div>
    <div className="container relative z-10 mx-auto px-4 md:px-6">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="mb-6 text-3xl font-bold text-white md:text-4xl">
          Ready to Transform How You Travel?
        </h2>
        <p className="mb-8 text-lg text-gray-300">
          Join our global community today and start connecting with travelers
          and local experts worldwide.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <a href="/community" className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-11 rounded-md px-8 bg-primary text-white hover:bg-primary/90">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-users mr-2 h-5 w-5"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx={9} cy={7} r={4} />
              <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
            Join Our Community
          </a>
          <a href="/experts">
            <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-11 rounded-md px-8 border-white/20 bg-white/5 text-white hover:bg-white/10">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-globe mr-2 h-5 w-5"
              >
                <circle cx={12} cy={12} r={10} />
                <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
                <path d="M2 12h20" />
              </svg>
              Explore Platform
            </button>
          </a>
        </div>
      </div>
    </div>
  </section>
</main>



      <Footer />
    </>
  );
};

export default Index;
